import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type DSolutionsBadgeData = {
  marginBottom?: string
  marginTop?: string
}

export const dSolutionsBadge: DynamicContentType<DSolutionsBadgeData> = {
  name: 'dSolutionsBadge',
  viewName: 'DSolution Badge',
  featureKey: 'dSolutionsBadge',
  icon: LucideIconName.ShieldCheck,
  default: false,
  uuid: '',
  data: {},
}
